if (!window.crypto) {
  window.crypto = window.msCrypto
}
